import defaultDisplayContent from '@/defaultDisplayContent/htmlDisplay';

export default {
  displayContent: state => type => {
    if (state.displayContentConfig) {
      const configs = state.displayContentConfig.find(d => {
        if (d.display_content_localization === type) {
          // return d.display_content_language ? d.display_content_language === getters.getLanguage : true;
          return true;
        }
        return false;
      });

      if (configs) {
        return configs.display_content_json || configs.display_content_html;
      }
    }

    const defaultConfig = defaultDisplayContent[type];

    // return defaultConfig && defaultConfig[getters.getLanguage] ? defaultConfig[getters.getLanguage] : defaultConfig;
    return defaultConfig && defaultConfig.fr ? defaultConfig.fr : defaultConfig;
  },
  calendarDay: state => uid => {
    if (state.calendarDays.length) {
      const calendarDay = state.calendarDays.find(day => {
        if (day.uid === uid) {
          return true;
        }
        return false;
      });
      if (calendarDay) {
        return calendarDay.date;
      }
      return null;
    }

    return null;
  },
  isImpersonateMode: state => !!state.impersonateData
};
